import { InjectableClass } from '@fino/lib-injection';

export class UploadController extends InjectableClass {
  constructor(controllerService, uploadService) {
    'ngInject';
    super({ controllerService, uploadService });
  }

  $onInit() {
    this.files = [];

    if (this.acceptFileTypes) {
      this.pattern = this.uploadService.createFilePattern(this.acceptFileTypes);
    }
  }

  uploadedFromDisk($files) {
    if ($files && $files.length) {
      if (this.multipleUpload) {
        this.files = this.files.concat($files);
        return;
      }

      if (this.singleUpload) {
        // get last pushed item.
        this.files = $files.slice($files.length - 1, $files.length);
      } else {
        $files.forEach((file) => this.uploadFile(file));
        this.files = this.files.concat($files);
      }
    }
  }

  uploadFile(file) {
    // Initial file upload progress
    file.progress = 1;

    // First check if there is an upload url defined to use for uploading the file
    if (this.uploadUrl) {
      this.uploadPromise = this.uploadService.upload(file, this.uploadUrl);
    }
    // Alternative use the given upload function which needs to return a promise
    else if (this.upload) {
      this.uploadPromise = this.upload({ file });
    }

    // Ensure the return value of the upload function is a promise
    if (!(this.uploadPromise && this.uploadPromise.then)) {
      throw new Error(
        'Given upload function does not return a promise. Given: ' +
          typeof this.uploadPromise
      );
    }

    const uploadDone = (fileId) => {
      file.fileId = fileId;
      file.uploaded = true;
      file.error = null;
      if (angular.isFunction(this.uploadDone)) {
        this.uploadDone({ fileId });
      }
    };

    const uploadFail = (error) => {
      file.progress = 0;
      file.uploaded = false;
      file.error = parseFileError(error);
      if (angular.isFunction(this.uploadFail)) {
        this.uploadFail({ error });
      }
    };

    const uploadProgress = (event) => {
      file.progress = Math.floor((event.loaded / event.total) * 100);
      if (angular.isFunction(this.uploadProgress)) {
        this.uploadProgress(event);
      }
    };

    const uploadFinally = () => {
      if (angular.isFunction(this.uploadFinally)) {
        this.uploadFinally();
      }
    };

    const parseFileError = (error) => {
      if (error) {
        if (error.data) {
          // If the given error has data as string, we try to use
          if (angular.isString(error.data)) {
            const { status, statusText } = error;
            return { code: status, message: statusText };
          }
          return error.data;
        }
      }
      return error;
    };

    // Start uploading
    this.uploadPromise
      .then(
        uploadDone.bind(this),
        uploadFail.bind(this),
        uploadProgress.bind(this)
      )
      .finally(uploadFinally.bind(this));

    // Trigger upload has been started
    if (angular.isFunction(this.uploadStart)) {
      this.uploadStart({ upload: this.uploadPromise, file });
    }

    return this.uploadPromise;
  }

  abortUpload() {
    if (this.uploadPromise) {
      this.uploadPromise.abort();
    }
  }
}
